module.exports = __webpack_public_path__ + "static/media/Approvals.a84e3eb0.svg";